"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.units = exports.baseUnit = void 0;

var _styledComponents = require("styled-components");

/**
 * Module dependencies.
 */

/**
 * Export `baseUnit`.
 */
var baseUnit = 8;
/**
 * Export `units`.
 */

exports.baseUnit = baseUnit;

var units = function units(unit) {
  return function (props) {
    return (0, _styledComponents.css)(["", "px"], unit * props.theme.baseUnit);
  };
};

exports.units = units;